import React, { useEffect, useContext } from 'react'

import GlobalContext from '../../context/GlobalContext'

interface PageWrapperProps {
  location: {
    pathname: string;
    [key: string]: any;
  };
  children: React.ReactNode;
  headerDark?: boolean;
  footerDark?: boolean;
}

// Type for the global context - ensure it matches methods actually used
interface GlobalContextType {
  saveLocation: (location: any) => void;
  goHeaderDark: () => void;
  goHeaderLight: () => void;
  goFooterDark: () => void;
  goFooterLight: () => void;
  [key: string]: any;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  location,
  children,
  headerDark = false,
  footerDark = false,
}) => {
  // Using type assertion to avoid TypeScript errors with context
  const gContext = useContext(GlobalContext) as GlobalContextType

  useEffect(() => {
    gContext.saveLocation(location)
    if (headerDark) {
      gContext.goHeaderDark()
    } else {
      gContext.goHeaderLight()
    }

    if (footerDark) {
      gContext.goFooterDark()
    } else {
      gContext.goFooterLight()
    }
  }, [gContext, headerDark, footerDark, location])

  return <>{children}</>
}

export default PageWrapper
